// Drag & drop
export const TodoGhostEntryCSSClass = 'ghost';
export const RestrictionAreaCSSClass = 'restriction-area';
export const TodoPlannerDropzoneCSSClass = 'todo-planner-dropzone';
export const DropTargetCSSClass = 'drop-target';
export const CanDropCSSClass = 'can-drop';

// Container
export const TodoEntryHost = 'todo-entry-host';
export const TodoEntryFixIntervalWrapperCSSClass = 'todo-entry-fix-interval-wrapper';
export const TodoEntryVariableIntervalWrapperCSSClass = 'todo-entry-variable-interval-wrapper';
export const TodoEntryFixIntervalCSSClass = 'fix-interval';
export const TodoEntryVariableIntervalCSSClass = 'variable-interval';

// To-do entries
export const TodoEntryWrapperCSSClass = 'todo-entry-wrapper';
export const TodoEntryCompletedCheck = 'completed-check';

// Add to-do button
export const AddToDoButtonWrapperCSSClass = 'add-todo-wrapper';

// Attributes
export const TodoContainerDateAttribute = 'data-date';

// Constant values
export const TodoPlannerFixIntervalContainerGap = 4;
